import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="bg-cream-dark py-24 md:py-32 relative overflow-hidden" data-id="element-95" data-mp="3udf8az5tp7i7">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold-main/30 to-transparent" data-id="element-96" data-mp="c8c035kk8fdk"></div>
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold-main/30 to-transparent" data-id="element-97" data-mp="87jqgb7s08gr"></div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-98" data-mp="h6dlhx5gkqs7">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-10" data-id="element-99" data-mp="vurw4u949jjb">
          <div className="space-y-4" data-id="element-100" data-mp="zxegka3gk26h">
            <p className="font-lora text-xl text-brown-light italic" data-id="element-101" data-mp="zua7ozf1si9h">
              Algunos libros informan.
            </p>
            <h2 className="text-3xl md:text-5xl font-playfair font-bold text-brown-dark leading-tight" data-id="element-102" data-mp="2h3hnymusku5b">
              Este libro transforma la forma en que vives los momentos
              importantes de tu vida.
            </h2>
          </div>

          <div className="bg-white p-8 md:p-12 rounded-sm shadow-sm border border-gold-main/10 max-w-2xl mx-auto" data-id="element-103" data-mp="2r3ibkkzp1wfb">
            <p className="font-lora text-lg text-brown-dark mb-6" data-id="element-104" data-mp="2v38z8ftxbwfm">
              Si sientes que necesitas:
            </p>
            <ul className="space-y-3 font-lora text-brown-light text-left max-w-xs mx-auto mb-8" data-id="element-105" data-mp="34tc0f3b78gp1">
              <li className="flex items-center gap-3" data-id="element-106" data-mp="39sf68pz06qy2">
                <span className="text-gold-main" data-id="element-107" data-mp="39r3tw1rhsavc">✦</span> cerrar ciclos
              </li>
              <li className="flex items-center gap-3" data-id="element-108" data-mp="3esjfpw1hules">
                <span className="text-gold-main" data-id="element-109" data-mp="3it3a4ruonax8">✦</span> sanar emociones
              </li>
              <li className="flex items-center gap-3" data-id="element-110" data-mp="3iqqrsdl0iyjn">
                <span className="text-gold-main" data-id="element-111" data-mp="1jp4wbwirpbqi">✦</span> crear espacios con
                sentido
              </li>
              <li className="flex items-center gap-3" data-id="element-112" data-mp="1er3cvahfjaei">
                <span className="text-gold-main" data-id="element-113" data-mp="1sgx0xql41qn6">✦</span> honrar momentos
                importantes
              </li>
            </ul>
            <p className="font-playfair font-semibold text-xl text-gold-dark italic" data-id="element-114" data-mp="1nodq31dt59m2">
              entonces este libro fue creado para ti.
            </p>
          </div>

          <div className="space-y-6 pt-4" data-id="element-115" data-mp="1xgjgw7sbpkzo">
            <p className="font-lora text-lg text-brown-dark" data-id="element-116" data-mp="1xhufzuatq4kg">
              Accede hoy mismo por solo{' '}
              <span className="font-bold text-2xl text-gold-dark" data-id="element-117" data-mp="2bd6or5ltdvkd">
                $14.99 USD
              </span>
            </p>
            <CTAButton className="px-12 py-5 text-xl" data-id="element-118" data-mp="h0ynlaiwgig5">
              Quiero empezar ahora
            </CTAButton>
          </div>
        </motion.div>
      </div>
    </section>;
}